import {
    ArrowDownTrayIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    MagnifyingGlassIcon,
    PlusIcon,
    XMarkIcon,
} from "@heroicons/react/24/outline";
import { ProductCatalogSelectFilter } from "../productCatalog/ProductCatalogSelectFilter";

const amberWhenActive = (isActive) =>
    isActive ? "!border-amber-400 !text-amber-700 !bg-amber-50 focus:!ring-amber-400" : "";

const BomToolbar = ({
    filters,
    onFilterChange,
    onClearFilters,
    hideAddButton = false,
    secondaryOptions = [],
    secondaryPlaceholder = "All Products",
    secondaryFilterKey = "productName",
    canToggleExpand = false,
    allExpanded = false,
    onToggleExpand,
    addLabel,
    onAdd,
    onExport,
    showExport = true,
    searchPlaceholder = "Search SKU or product...",
    /** When set, renders a second catalog-style select for `filters.status` (e.g. product BOM). */
    statusOptions = null,
    statusAllLabel = "All statuses",
}) => {
    const secondaryValue = filters[secondaryFilterKey] || "all";
    const secondarySelected =
        secondaryValue === "all" || secondaryValue === "" ? [] : [String(secondaryValue)];

    const statusValue = filters.status ?? "all";
    const statusSelected = statusValue === "all" || statusValue === "" ? [] : [String(statusValue)];

    const hasFilters =
        Boolean(filters.search) ||
        filters[secondaryFilterKey] !== "all" ||
        (statusOptions && filters.status !== "all");

    return (
        <div className="flex flex-shrink-0 flex-wrap items-center gap-2 bg-gray-50 px-4 py-2.5">
            <div className="relative max-w-sm flex-1">
                <MagnifyingGlassIcon className="pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-gray-400" />
                <input
                    type="search"
                    value={filters.search}
                    onChange={(e) => onFilterChange("search", e.target.value)}
                    placeholder={searchPlaceholder}
                    className="h-[37px] w-full rounded-md no-search-input-chrome border border-gray-200 bg-white pl-8 pr-8 text-sm text-gray-700 outline-none placeholder:text-gray-400 focus:border-gray-400"
                />
                {filters.search ? (
                    <button
                        type="button"
                        onClick={() => onFilterChange("search", "")}
                        className="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700"
                    >
                        <XMarkIcon className="h-3.5 w-3.5" />
                    </button>
                ) : null}
            </div>
            {statusOptions ? (
                <ProductCatalogSelectFilter
                    allLabel={statusAllLabel}
                    selectClassname="w-[180px] flex-shrink-0"
                    buttonSelectedClassname={amberWhenActive(statusSelected.length > 0)}
                    options={statusOptions}
                    selectedOptions={statusSelected}
                    onChange={(next) => {
                        onFilterChange("status", next.length === 0 ? "all" : next[0]);
                    }}
                    renderOption={(option) => <span className="text-gray-900">{option.label}</span>}
                />
            ) : null}
            <ProductCatalogSelectFilter
                allLabel={secondaryPlaceholder}
                selectClassname="w-[200px]"
                buttonSelectedClassname={amberWhenActive(secondarySelected.length > 0)}
                options={secondaryOptions}
                selectedOptions={secondarySelected}
                onChange={(next) => {
                    onFilterChange(secondaryFilterKey, next.length === 0 ? "all" : next[0]);
                }}
                renderOption={(option) => <span className="text-gray-900">{option.label}</span>}
            />
            {hasFilters ? (
                <button
                    type="button"
                    onClick={onClearFilters}
                    className="flex h-8 items-center gap-1 px-2 text-sm text-gray-500 hover:text-gray-900"
                >
                    <XMarkIcon className="h-3 w-3" />
                    Clear
                </button>
            ) : null}
            <div className="flex-1" />
            {canToggleExpand ? (
                <button
                    type="button"
                    onClick={onToggleExpand}
                    className="inline-flex h-8 flex-shrink-0 items-center gap-1 rounded-md border border-gray-200 bg-white px-3 text-sm text-gray-700 hover:bg-gray-50"
                >
                    {allExpanded ? <ChevronUpIcon className="h-3.5 w-3.5" /> : <ChevronDownIcon className="h-3.5 w-3.5" />}
                    {allExpanded ? "Collapse All" : "Expand All"}
                </button>
            ) : null}
            {showExport ? (
                <button
                    type="button"
                    onClick={onExport}
                    className="inline-flex h-8 flex-shrink-0 items-center gap-1 rounded-md border border-gray-200 bg-white px-3 text-sm text-gray-700 hover:bg-gray-50"
                >
                    <ArrowDownTrayIcon className="h-3.5 w-3.5" />
                    Export CSV
                </button>
            ) : null}
            {!hideAddButton ? (
                <button
                    type="button"
                    onClick={onAdd}
                    className="inline-flex h-8 flex-shrink-0 items-center gap-1 rounded-md bg-[#111] px-3 text-sm font-medium text-white hover:bg-[#333]"
                >
                    <PlusIcon className="h-3.5 w-3.5" />
                    {addLabel}
                </button>
            ) : null}
        </div>
    );
};

export default BomToolbar;
